<template>
  <mia-form :is-loading="$wait.is('loading provision accountings')">
    <mia-form-section
      vertical
      no-padding
    >
      <template #titleWrapper>
        <div class="p-4 flex justify-between">
          <h3 class="py-0 my-0 text-xl text-gray-800">
            Bereits gebuchte Prämienforderungen und erhaltene Zahlungen
          </h3>

          <div>
            <button
              type="button"
              class="text-orange-mia hover:underline focus:outline-none focus:underline"
              @click="toggleDeletedProvisionsVisibility"
            >
              Gelöschte Einträge {{ hideDeletedProvisions ? 'anzeigen' : 'verstecken' }}
            </button>
          </div>
        </div>
      </template>

      <template #default>
        <mia-car-provision-accountings-table
          class="mt-4"
          :car="car"
          :provisions="filteredProvisions"
          :payments="payments"
          :stats="stats"
          @provisions-changed="onProvisionsChanged"
        >
          <template
            v-if="hideDeletedProvisions && deletedProvisions.length > 0"
            #additionalRows
          >
            <tr>
              <td
                colspan="7"
                class="hover:bg-gray-400 cursor-pointer"
                @click="hideDeletedProvisions = false"
              >
                <div class="italic flex flex-col items-center">
                  <div>{{ deletedProvisions.length }} ausgeblendete{{ deletedProvisions.length === 1 ? 'r' : '' }} Inhalt{{ deletedProvisions.length === 1 ? '' : 'e' }}</div>
                  <div class="leading-3">
                    ...
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </mia-car-provision-accountings-table>
      </template>
    </mia-form-section>

    <template #actions>
      <div
        class="flex-1 flex"
        :class="{
          'justify-between items-end': authUser.item_is_allowed_provision_notes && car.own_car,
          'justify-end': !authUser.item_is_allowed_provision_notes || !car.own_car
        }"
      >
        <mia-owns-car>
          <mia-is-allowed to="provision_notes">
            <div class="w-1/2">
              <mia-feature-textarea
                v-model="provisionNotes"
                label="Notizen"
              />
              <mia-submit-button
                type="button"
                class="mt-2"
                :disabled="$wait.any"
                label="Notizen Speichern"
                size="small"
                @click="updateNotes"
              />
            </div>
          </mia-is-allowed>
        </mia-owns-car>

        <mia-submit-button
          :disabled="$wait.any"
          :is-loading="$wait.is('updating notes')"
          label="Prämienforderungen drucken"
          type="button"
          @click="print"
        />
      </div>
    </template>
  </mia-form>
</template>

<script>
import { getProvisionAccountings } from '@/api/provisions'
import Form from '@/components/ui/widgets/Form.vue'
import FormSection from '@/components/ui/widgets/FormSection.vue'
import ProvisionAccountingsTable from '@/components/cars/tables/ProvisionAccountingsTable.vue'
import SubmitButton from '@/components/cars/edit/SubmitButton.vue'
import FeatureTextarea from '@/components/cars/edit/FeatureTextarea.vue'
import { updateProvisionNotes } from '@/api/cars'

export default {
  name: 'MiaCarEditProvisionAccountingsForm',

  components: {
    'mia-car-provision-accountings-table': ProvisionAccountingsTable,
    'mia-feature-textarea': FeatureTextarea,
    'mia-form': Form,
    'mia-form-section': FormSection,
    'mia-submit-button': SubmitButton
  },

  data() {
    return {
      provisions: [],
      payments: [],
      stats: {
        requested: 0,
        paid: 0,
        diff: 0
      },
      provisionNotes: '',
      hideDeletedProvisions: true
    }
  },

  computed: {
    car: {
      get() {
        return this.$store.state.car.car
      },

      set(car) {
        this.$store.commit('setCar', car)
      }
    },

    regularProvisions() {
      return this.provisions.filter(provision => provision.item_provision_value > 0)
    },

    deletedProvisions() {
      return this.provisions.filter(provision => provision.item_provision_value === 0)
    },

    sortedProvisions() {
      return [...this.regularProvisions, ...this.deletedProvisions]
    },

    filteredProvisions() {
      return this.sortedProvisions.filter(provision => (this.hideDeletedProvisions ? provision.item_provision_value > 0 : true))
    }
  },

  watch: {
    car: {
      immediate: true,
      deep: true,
      async handler(car, oldCar) {
        if (oldCar && oldCar.id && parseInt(car.id, 10) === parseInt(oldCar.id, 10)) {
          return
        }

        if (this.authUser.item_is_allowed_provision_notes) {
          this.provisionNotes = this.car.item_provision_notes || ''
        }

        this.loadAccountings(car)
      }
    }
  },

  methods: {
    print() {
      // TODO: Printing does not work this way anymore
      mia.common.print($('.provision-accountings-table'))
    },

    async loadAccountings(car) {
      this.$wait.start('loading provision accountings')
      const accounting = await getProvisionAccountings(car.id)
      this.$wait.end('loading provision accountings')

      this.provisions = accounting.provisions
      this.payments = accounting.payments
      this.stats = accounting.stats
    },

    refresh() {
      this.loadAccountings(this.car)
    },

    async updateNotes() {
      this.$wait.start('updating notes')
      const [error] = await updateProvisionNotes(this.car.id, this.provisionNotes)
      this.$wait.end('updating notes')

      if (error) {
        window.eventBus.$emit('mia-error', {
          error: ['Die Notizen konnten nicht aktualisiert werden.']
        })
        return
      }

      window.eventBus.$emit('mia-info', {
        info: ['Notizen erfolgreich gespeichert.']
      })
    },

    toggleDeletedProvisionsVisibility() {
      this.hideDeletedProvisions = !this.hideDeletedProvisions
    },

    onProvisionsChanged() {
      this.refresh()
    }
  }
}
</script>
